var TrackingEventCategory;
(function (TrackingEventCategory) {
    TrackingEventCategory["NAVIGATION"] = "navigation";
    TrackingEventCategory["ECOMMERCE"] = "ecommerce";
    TrackingEventCategory["LOOK_IN"] = "shop";
})(TrackingEventCategory || (TrackingEventCategory = {}));
export { TrackingEventCategory };
